import templateUrl from './deviceControls.html'

/**
 * Device Controls component.
 *
 * Start, stop buttons and status polling
 *
 * @example
 *   <tmr-device-controls
 *     device="$ctrl.printer"
 *   ></tmr-device-controls>
 *
 * @type {ngComponent}
 * @prop {TmrResource} device
 */
export const tmrDeviceControls = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrDeviceControlsController',
  bindings: {
    device: '<',
  },
}

/**
 * Controller of component {@link tmrDeviceControls}.
 *
 * @type {ngController}
 */
export class tmrDeviceControlsController {
  static ngType = 'controller'

  constructor($interval, $timeout, TmrToast) {
    'ngInject'
    Object.assign(this, { $interval, $timeout, TmrToast })
  }

  $onInit() {
    // Milliseconds passed between printer status updates.
    this.statusUpdateInterval = 4000
    // Milliseconds passed between printer status steps (for loader).
    this.statusStepInterval = 100
    // Milliseconds before user can click on printer play/pause button again.
    this.buttonWait = 5000
    // Status colors.
    this.colors = {
      UNKNOWN: 'warn',
      STARTED: 'temeraGreen',
      STOPPED: 'warn',
      READY: 'temeraGreen',
      PRINTING: 'temeraGreen',
    }

    // Setup interval for status check.
    this.currentStatusInterval = 0
    this.statusStepIntervalPromise = this.$interval(
      () => this.statusStep(),
      this.statusStepInterval
    )
    this.checkStatus()
  }

  $onDestroy() {
    this.$interval.cancel(this.statusStepIntervalPromise)
  }

  start() {
    this.status = null
    this.buttonsDisabled = true
    return this.device
      .$start()
      .catch(err => this.TmrToast.exception(err))
      .then(() => this.$timeout(this.buttonWait))
      .then(() => (this.buttonsDisabled = false))
  }

  stop() {
    this.status = null
    this.buttonsDisabled = true
    return this.device
      .$stop()
      .catch(err => this.TmrToast.exception(err))
      .then(() => this.$timeout(this.buttonWait))
      .then(() => (this.buttonsDisabled = false))
  }

  checkStatus() {
    if (this.checkingStatus) return Promise.resolve()
    this.checkingStatus = true
    return this.device
      .$status()
      .then(status => (this.status = status))
      .catch(err => {
        this.status = 'UNKNOWN'
        this.TmrToast.exception(err)
      })
      .finally(() => (this.checkingStatus = false))
  }

  statusStep() {
    this.currentStatusInterval += this.statusStepInterval
    this.statusUpdatePercentage = Math.round(
      (this.currentStatusInterval * 100) / this.statusUpdateInterval
    )
    if (this.currentStatusInterval >= this.statusUpdateInterval) {
      this.currentStatusInterval = 0
      return this.checkStatus()
    }
  }
}
